














































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Users from '@/store/modules/Users';
import SignUpDialog from '@/views/Auth/SignUpDialog.vue';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Comments from '@/store/modules/Comments';
import MainCommentPanel from '@/components/common/MainCommentPanel.vue';
import Modelling from '@/store/modules/Modelling';
import CardTitle from '@/components/common/CardTitle.vue';

const usersModule = getModule(Users);
const workspaceOptionsModule = getModule(WorkspaceOptions)
const modellingModule = getModule(Modelling);
@Component({
    components: {
        SignUpDialog,
        ModelBuilderRecursiveGroupComp: () =>
            import('@/views/ModelBuilder/ModelBuilderRecursiveGroup.vue'),
        ModelBuilderForm: () =>
            import('@/views/ModelBuilder/ModelBuilder.vue'),
        MainCommentPanel,
        CardTitle
    },
})
export default class DiffDialog extends Vue {


    @Prop({type: Boolean, default: false})
    autofill!: boolean;

    @Prop({type: Boolean, default: null})
    
    open!: boolean | null;

    private dialog = false;

    get modelDiff() {
        return modellingModule.modelDiff;
    }

    private navDrawer = false;

    get isLoggedIn(): boolean {
        return usersModule.currentAuthUser !== null;
    }

    get openRight() {
        return workspaceOptionsModule.openRight;
    }

    set openRight(val) {
        workspaceOptionsModule.setOpenRight(val);
    }

    get factorResources() {
        return modellingModule.workingModelFactorResources;
    }

    get sandboxFactorResources() {
        return modellingModule.sandboxModelFactorResources;
    }
}
